import React, { useState } from 'react';
import styles from './ChatInput.module.scss';
import classnames from 'classnames';
import { Button } from '@zurich-primitives/button';
import { ReactComponent as SendIcon } from 'app/assets/Icons/Send.svg';
import { IChatInput } from './ChatInput.interface';
import { Tooltip } from 'react-tooltip';

export const ChatInput: React.FC<IChatInput> = ({
  onSendMessage,
  model,
  disabled,
  disabledMessage
}) => {
  const [input, setInput] = useState('');
  const [isActive, setIsActive] = useState(false);

  const handleSend = (): void => {
    onSendMessage(input, model);
    setInput('');
  };

  const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter' && input.trim()) {
      handleSend();
    }
  };

  return (
    <div
      className={classnames(styles['chat-input'], {
        [styles.active]: isActive && !disabled,
        [styles.disabled]: disabled
      })}
    >
      <input
        type="text"
        className={styles['input-field']}
        placeholder="Enter your question"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onFocus={() => setIsActive(true)}
        onBlur={() => setIsActive(!!input.trim())}
        onKeyDown={handleEnter}
        disabled={disabled}
        data-tooltip-id="chat-input-disabled-tooltip"
        data-tooltip-content={disabled ? disabledMessage : undefined}
      />
      <Button
        variant="icon"
        aria-label="Send message"
        className={styles['send-button']}
        onClick={handleSend}
        disabled={!input.trim()}
      >
        <Button.Icon>
          <SendIcon />
        </Button.Icon>
      </Button>

      {disabled && (
        <Tooltip
          id="chat-input-disabled-tooltip"
          className={styles['input-tooltip']}
          noArrow
        />
      )}
    </div>
  );
};
